<div class="mb-2">
	<label class="form-label fw-semibold" [for]="id"
		>{{ label }}<span class="text-danger" *ngIf="isRequired">*</span></label
	>
	<angular-editor
		#editor
		[config]="editorConfig"
		[id]="id"
		class="form-control"
		[ngClass]="mensagemErro ? 'is-invalid' : ''"
		[placeholder]="placeholder"
		[formControlName]="controlName"
		[maxlength]="maxLength || null">
	</angular-editor>
	<div class="invalid-feedback position-inherit mt-0" *ngIf="mensagemErro">
		{{ mensagemErro }}
	</div>
</div>
